import ServiceBase from "utils/ServiceBase";

const BASE = "/ggg/api/v3.0/qr-prepaid";

// `_cartIndex` chỉ dùng ở FE (đồng bộ giỏ hàng), không gửi lên BE.
const stripCartIndex = (lines) =>
  (lines || []).map((line) => {
    // eslint-disable-next-line no-unused-vars
    const { _cartIndex, ...rest } = line || {};
    return rest;
  });

export const qrPrepaidInit = ({ menuCode, deviceId, tableCode, language }) =>
  ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/init`,
    data: {
      "menu-code": menuCode,
      "device-id": deviceId,
      "table-code": tableCode,
      language,
    },
  });

export const qrPrepaidCalculate = ({
  prepaidId,
  dishs,
  combos,
  dishsDiscount,
  hotpot,
}) =>
  ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/calculate`,
    data: {
      "prepaid-id": prepaidId,
      dishs: stripCartIndex(dishs),
      combos: stripCartIndex(combos),
      "dishs-discount": dishsDiscount || [],
      ...(hotpot ? { hotpot } : {}),
    },
  });

export const qrPrepaidAppLoginInit = ({ prepaidId, sessionId, callbackUrl }) =>
  ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/app-login/init`,
    data: {
      "prepaid-id": prepaidId,
      "session-id": sessionId,
      "callback-url": callbackUrl,
    },
  });

export const qrPrepaidAppLoginCallback = ({ shortToken, state }) =>
  ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/app-login/callback`,
    data: {
      "short-token": shortToken,
      state,
    },
  });

export const qrPrepaidPaymentCreate = ({
  prepaidId,
  serviceType,
  takeTax,
  rkPaymentCode,
  expectedTotal,
  dishs,
  combos,
  dishsDiscount,
  appInApp,
  partnerId,
}) => {
  const payload = {
    "prepaid-id": prepaidId,
    "service-type": serviceType,
    "take-tax": takeTax,
    "rk-payment-code": rkPaymentCode,
    "expected-total": expectedTotal,
    dishs: stripCartIndex(dishs),
    combos: stripCartIndex(combos),
    "dishs-discount": dishsDiscount || [],
    ...(appInApp ? { "app-in-app": true, "partner-id": partnerId } : {}),
  };
  return ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/payment/create`,
    data: payload,
  });
};
export const qrPrepaidPaymentCheck = ({ prepaidId }) =>
  ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/payment/check`,
    data: {
      "prepaid-id": prepaidId,
    },
  });

export const qrPrepaidPaymentConfirm = ({ prepaidId }) =>
  ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/payment/confirm`,
    data: {
      "prepaid-id": prepaidId,
    },
  });

export const qrPrepaidDetail = ({ prepaidId }) =>
  ServiceBase.requestJson({
    method: "GET",
    url: `${BASE}/detail`,
    data: {
      "prepaid-id": prepaidId,
    },
  });

export const qrPrepaidCancel = ({ prepaidId }) =>
  ServiceBase.requestJson({
    method: "POST",
    url: `${BASE}/cancel`,
    data: {
      "prepaid-id": prepaidId,
    },
  });
